import { useQuery } from '@tanstack/react-query';
import {
  AmazonAccountRow,
  CreateGrepsrCredentialBody,
  SkaiPacvueAccountOption,
  UpdateAspMappingsBody
} from '@blisspointmedia/bpm-types/dist/AmazonSPAPI';
import { AmazonLambdaFetch, awaitJSON } from '@src/utils/fetch-utils';

const loadSellingPartnerAccounts = async (company: string): Promise<AmazonAccountRow[]> => {
  const res = await AmazonLambdaFetch('/getSellingPartnerAccounts', { params: { company } });
  return awaitJSON<AmazonAccountRow[]>(res);
};

export const useSellingPartnerAccounts = (company: string) =>
  useQuery({
    meta: { suppressGlobalError: true },
    queryKey: ['sellingPartnerAccounts', company],
    enabled: Boolean(company),
    queryFn: () => loadSellingPartnerAccounts(company)
  });

const loadSkaiPacvueAccountOptions = async (
  company: string
): Promise<SkaiPacvueAccountOption[]> => {
  const res = await AmazonLambdaFetch('/getSkaiPacvueAccountOptions', { params: { company } });
  return awaitJSON<SkaiPacvueAccountOption[]>(res);
};

export const useSkaiPacvueAccountOptions = (company: string) =>
  useQuery({
    meta: { suppressGlobalError: true },
    queryKey: ['skaiPacvueAccountOptions', company],
    enabled: Boolean(company),
    queryFn: () => loadSkaiPacvueAccountOptions(company)
  });

export const updateAspMappings = async (params: UpdateAspMappingsBody): Promise<void> => {
  const res = await AmazonLambdaFetch('/updateAspMappings', {
    method: 'POST',
    body: params
  });
  await awaitJSON<string>(res);
};

export const createGrepsrCredential = async (
  params: CreateGrepsrCredentialBody
): Promise<string> => {
  const res = await AmazonLambdaFetch('/createGrepsrCredential', {
    method: 'POST',
    body: params
  });
  return awaitJSON<string>(res);
};

interface CheckAuthorizationParams {
  company: string;
  applicationType: string;
  marketplace: string;
  brand: string;
}

export const checkSellingPartnerAuthorization = async (
  params: CheckAuthorizationParams
): Promise<string> => {
  const res = await AmazonLambdaFetch('/checkSellingPartnerAuthorization', { params });
  return awaitJSON<string>(res);
};
